module.exports = __webpack_public_path__ + "img/锂电行业数字化转型场景图谱.b0814e70.jpg";